import { clearTag, downloadTag } from "api/tags";
// import { downloadExp } from "api/expression";

const actionApiConfig = {
  downloadTag,
  downloadExp: null,
  clearTag,
};
export default actionApiConfig;